import { GTMEvent } from '../GTM'
import { formatPrice } from '@corratech/pylot-seo'
import { itemHasKeys } from '@corratech/pylot-utils'

export type GTMProductData = {
    name: string
    id: string
    price: number
    currencyCode?: string
    category?: string
    categoryPath?: string
    brand?: string
    product_type?: string
    discount?: number
}

export const isValidProductItemData = (
    data: unknown
): data is GTMProductData => {
    return itemHasKeys(data, ['name', 'id', 'price'])
}
export const pushPromotionClick = (data: Record<string, unknown>): GTMEvent => {
    if (!isValidProductItemData(data)) {
        console.info('Invalid GTM PDP data')
        return { event: '' }
    }
    const {
        name,
        id,
        price,
        currencyCode,
        categoryPath,
        brand,
        discount
    } = data
    const isClient = typeof window !== 'undefined'
    const isPrmotionalProductTileClicked =
        isClient && localStorage!.getItem('promotionBanner')
    return {
        event: 'select_promotion',
        ecommerce: {
            promotion_name: isPrmotionalProductTileClicked,
            products: [
                {
                    name,
                    id,
                    price: formatPrice(Number(price)),
                    discount,
                    currency_code: currencyCode,
                    category: categoryPath,
                    item_list_name: isPrmotionalProductTileClicked,
                    brand
                }
            ]
        },
        _clear: true
    }
}
